<app-layout>
  <div class="main">
    <div class="header-table">
      <div class="title">
        <app-titulo>Parametrização de Serviços</app-titulo>
      </div>
      <div class="header-buttons">
        <app-botao
          type="primario"
          text="Cadastrar Serviço"
          icon="assets/add.svg"
          (click)="navegarServico()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Lista de Serviços<br /></div>

        <div class="inputs-group">
          <div class="horas">
            <app-input
              type="select"
              width="160px"
              label="Tempo por Cobrança"
              name="VL_PRMT"
              placeholder="Selecione"
              [selectData]="horaCobrancaOptions"
              [(ngModel)]="horaCobrancaSelecionado"
              [disabled]="cobrarUnicoAtivo"
              (ngModelChange)="editarHelperHelper(3, $event)">
            </app-input>
          </div>

          <div class="tolerancia">
            <app-input
              type="select"
              width="190px"
              label="Tolerância para Cobrança"
              name="VL_PRMT"
              placeholder="Selecione"
              [selectData]="toleranciaOptions"
              [(ngModel)]="toleranciaSelecionado"
              [disabled]="cobrarUnicoAtivo"
              (ngModelChange)="editarHelperHelper(1, $event)">
            </app-input>
          </div>

          <div class="multiplicador">
            <app-input
              type="select"
              width="230px"
              label="Multiplicador de Agendamento"
              name="VL_PRMT"
              placeholder="Selecione"
              [selectData]="multiplicadorOptions"
              [(ngModel)]="multiplicadorSelecionado"
              [disabled]="cobrarUnicoAtivo"
              (ngModelChange)="editarHelperHelper(2, $event)">
            </app-input>
          </div>

          <div class="pre-patio">
            <app-input
              width="160px"
              label="Valor Pré-Pátio (R$)"
              name="VL_PRMT"
              placeholder="0,00"
              [(ngModel)]="prePtioSelecionado"
              (ngModelChange)="editarHelperHelper(5, $event)">
            </app-input>
          </div>

          <div class="cobrar-unico">
            <label>Cobrança Única</label>
            <label class="switch">
              <input
                type="checkbox"
                [(ngModel)]="cobrarUnicoSelecionado"
                (ngModelChange)="toggleCobrarUnico($event)">
              <span class="slider"></span>
            </label>
          </div>
        </div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
</app-layout>
